import React from 'react';
import Container from '../../v2/container';
import Shipment from './Shipment';
import { useShipmentSubscription } from './Shipment.hooks';
import { getIdParam } from './helpers';

const ShipmentDetailPage = (props) => {
  const shipmentId = getIdParam(props);
  useShipmentSubscription({ shipmentId });

  return (
    <Container className="py-6" useMaxWidth={false}>
      <Shipment {...props} />
    </Container>
  );
};
export default ShipmentDetailPage;
